import React, { useState } from "react";
import { useSnackbar } from "notistack";
import Loading from "../../../components/loading";
import {
    Button,
    DialogActions,
    DialogContent,
    Divider,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { FTextField, FFilePicker, FSwitch } from "../../../components/form-elements";
import DialogTitle from "../../../components/dialog-title";
import brandsService from "../../../services/brands.service";

const emptyValues = {
    seoTitle: "",
    seoDescription: "",
};
const formSchema = Yup.object().shape({});

export default function SeoFormModalContent({ close, data }) {
    const [waiting, setWaiting] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { id, ...initialValues } = data || {};

    const handleError = (error) => {
        let message;
        let variant;
        switch (error) {
            case "NameTaken":
                message = "این نام استفاده شده است.";
                variant = "error";
                break;
            case "BrandNotfound":
                message = "برند مورد نظر یافت نشد.";
                variant = "error";
                break;
            case "DuplicateName":
                message = "این نام تکراری است.";
                variant = "error";
                break;
            default:
                message = "اتفاقی افتاده، لطفا بعدا تلاش کنید.";
                variant = "error";
        }
        enqueueSnackbar(message, { variant });
    };

    const handleSubmit = async (model) => {
        setWaiting(true);
        let op;
        op = await brandsService.seoBrand(id, {
            main_title: model.main_title,
            seo_title: model.seo_title,
            canonical: model.canonical,
            alt: model.alt,
            seo_description: model.seo_description,
        });
        const { error } = op;
        setWaiting(false);
        if (error) {
            handleError(error);
            return;
        }
        close(true);
    };

    return (
        <Loading isLoading={waiting} overlay>
            <DialogTitle onClose={() => close()}>
                ویرایش سئو برند
            </DialogTitle>
            <Divider />
            <Formik
                initialValues={id ? initialValues : emptyValues}
                onSubmit={handleSubmit}
                validationSchema={formSchema}
            >
                {({ isSubmitting, values }) => (
                    <Form autoComplete="off">
                        <DialogContent>
                            <FTextField name="main_title" label="عنوان اصلی" autoFocus />  
                            <FTextField name="seo_title" label="عنوان سئو" />  
                            <FTextField name="canonical" label="آدرس اصلی" />  
                            <FTextField name="alt" label="alt عکس اصلی" />  
                            <FTextField name="seo_description" label="توضیحات سئو" type="textarea" multiline rows={4} />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                ذخیره
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Loading>
    );
}
